export const PAGE_UI_PAGE_LOADING_TOGGLE = 'PAGE_UI_PAGE_LOADING_TOGGLE';
export const PAGE_UI_PAGE_LOADING_SETTING = 'PAGE_UI_PAGE_LOADING_SETTING';



// WEBPACK FOOTER //
// ./src/components/page/PageLoading/flow/actionType.js